<template>
  <v-card>
    <v-card-text>
      <v-row class="ma-2">
        <small><b>{{ $t('payment.application.actionsHeader') }}</b></small>
        <v-spacer/>
        <v-btn
          x-small
          rounded
          color="primary"
          @click="resetWorkflowActions"
          :disabled="!canUserEdit"
        >
          <v-icon small class="mr-1">mdi-restore</v-icon>
          {{ $t('payment.application.reset') }}
        </v-btn>
      </v-row>
      <v-timeline
        align-top
        dense
      >
        <v-timeline-item
          v-for="(action, index) in actions"
          :key="index"
          :color="action.actualDate ? 'primary' : 'primary lighten-3'"
          small
        >
          <v-row class="">
            <v-col>
              <v-row align-items="baseline">
                <v-col cols="6" class="pb-0">
                  <strong>{{(action.actualDate || action.plannedDate) | formatDate}}</strong>
                </v-col>
                <v-col cols="6" class="pb-0">{{action.name}}</v-col>
              </v-row>
              <v-row>
                <v-col cols="12" v-if="action.comment" class="font-weight-bold py-0">{{action.comment}}</v-col>
                <v-col cols="12" v-if="action.actualDate" class="py-0">{{ $t('payment.application.performedBy') }} {{ action.user }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="3">
              <SubmitButton
                v-if="action.isActive"
                block
                small
                @click="handlePerformAction(action, index)"
                :disabled="!canUserEdit"
                :label="$t('payment.application.perform')"
              />
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
import { DATE_FORMAT, DEFAULT_PAYMENT_APPLICATION } from '@/helpers'
import { mapState } from 'vuex'

export default {
  name: 'PaymentApplicationTimeline',
  props: {
    application: {
      type: Object,
      default: () => (DEFAULT_PAYMENT_APPLICATION)
    }
  },
  computed: {
    ...mapState({
      canUserEdit: state => state.userPermissionsToContract.canUserEdit
    }),
    actions () {
      return this.application.workflowSteps.map((action) => ({
        ...action,
        minActualDate: dayjs(action.plannedDate).subtract(action.dueInDays, 'day').format(DATE_FORMAT)
      }))
    }
  },
  methods: {
    async resetWorkflowActions () {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        scope: {
          message: this.$t('payment.application.resetConfirm'),
          subtitle: this.$t('payment.application.resetConsequences')
        },
        handlers: {
          no: () => { },
          yes: () => {
            this.$emit('reset-actions')
          }
        }
      })
    },
    handlePerformAction (action, index) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'PerformActionForm',
        options: { maxWidth: 650 },
        scope: {
          step: action,
          application: this.application
        },
        handlers: {
          performaction: ({ applicationField, actualDate, comment }) => this.$emit('perform-action', { action, index, applicationField, actualDate, comment })
        }
      })
    }
  }
}
</script>
